export const SHOW_UPLOAD_DOCUMENTS_MODAL =
    'page/SHOW_UPLOAD_DOCUMENTS_MODAL' as const;

export const UPLOAD_DOCUMENT = 'page/UPLOAD_DOCUMENT' as const;
export const UPDATE_DOCUMENT_STATUS_ON_ERROR =
    'page/UPDATE_DOCUMENT_STATUS [error]' as const;
export const UPDATE_DOCUMENT_STATUS_ON_COMPLETED =
    'page/UPDATE_DOCUMENT_STATUS [completed]' as const;

export const ADD_TO_DOCUMENT_PENDING_LIST =
    'page/ADD_TO_DOCUMENT_PENDING_LIST' as const;
